import { computed, Directive, effect, signal, Signal } from '@angular/core';
import { outputFromObservable, toObservable } from '@angular/core/rxjs-interop';
import { ItemId, ProductId, stringifyItemId, stringifyProductId } from 'products-data';

@Directive()
export abstract class ProductOrItemComponentBase<TId extends ProductId | ItemId | null> {
  public abstract readonly id: Signal<TId | null>;
  public readonly productId = computed(() => ProductId.parse(stringifyProductId(this.id())));
  public readonly itemId = computed(() => ItemId.parse(stringifyItemId(this.id())));

  private readonly _loading = signal<boolean>(false);
  public readonly loading = this._loading.asReadonly();
  public readonly loadingChanged = outputFromObservable(toObservable(this.loading), { alias: 'loading' });
  protected computeIsLoading(): Signal<boolean> {
    return signal(false).asReadonly();
  }

  private readonly _hasContent = signal<boolean>(false);
  protected computeHasContent(): Signal<boolean> {
    return signal(true).asReadonly();
  }
  public readonly hasContent = this._hasContent.asReadonly();
  public readonly hasContentChanged = outputFromObservable(toObservable(this.hasContent), { alias: 'hasContent' });

  protected readonly idType = computed(() => {
    const id = this.id();
    if (!id) {
      return 'none';
    }
    if ('productType' in id || 'productOptions' in id) {
      return 'item';
    }
    return 'product';
  });

  // protected readonly thumbnailUrl = computed(() =>
  //   this.productId() ? `https://api.idealsupply.com/products/v1/products/${this.productId()}/thumbnail` : '',
  // );

  constructor() {
    effect(() => this._loading.set(this.computeIsLoading()()));
    effect(() => this._hasContent.set(this.computeHasContent()()));
  }
}
